const round = (num) => {
  return Math.round((num + Number.EPSILON) * 100) / 100
}

const size_info = (size) => {
  const kb = size / 1024;
  const mb = size / 1024 / 1024;
  const gb = size / 1024 / 1024 / 1024;

  if (kb < 1024) {
    return `${round(kb)} KB`;
  } else if (mb < 1024){
    return `${round(mb)} MB`;
  } else if (gb < 1024) {
    return `${round(gb)} GB`;
  }

  return size;
}

const show_wait = () => {
  document.getElementById('wait').classList.remove('hidden');  
}

const hide_wait = () => {
  document.getElementById('wait').classList.add('hidden');  
}

// Tüm submit düğmeleri wait göstersin
document.querySelectorAll('.show-wait-on-click').forEach((element)=>{
  element.addEventListener('click',(event)=>{
    show_wait();
  })
})


export { round, size_info, show_wait, hide_wait };